import { createMap, constructUsing } from "@automapper/core";
import { ServerLicenseTypeTypeName, LicenseTypeTypeName } from "./constants.js";
import { LicenseType } from "./types.js";
class LicenseMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      ServerLicenseTypeTypeName,
      LicenseTypeTypeName,
      constructUsing((m) => {
        const licenseTypeMapper = {
          CURACAO: LicenseType.CURACAO,
          TOBIQUE: LicenseType.TOBIQUE,
          PHILIPPINES: LicenseType.PH,
          SOUTHKOREA: LicenseType.KR,
          CHINA: LicenseType.CHINA,
          ANJOUAN: LicenseType.ANJOUAN,
          CIS: LicenseType.CIS
        };
        return licenseTypeMapper[m];
      })
    );
    createMap(
      mapper,
      LicenseTypeTypeName,
      ServerLicenseTypeTypeName,
      constructUsing((m) => {
        const licenseTypeMapper = {
          [LicenseType.CURACAO]: "CURACAO",
          [LicenseType.TOBIQUE]: "TOBIQUE",
          [LicenseType.PH]: "PHILIPPINES",
          [LicenseType.KR]: "SOUTHKOREA",
          [LicenseType.CHINA]: "CHINA",
          [LicenseType.ANJOUAN]: "ANJOUAN",
          [LicenseType.CIS]: "CIS"
        };
        return licenseTypeMapper[m];
      })
    );
  }
}
export {
  LicenseMapping
};
//# sourceMappingURL=mapper.js.map
